module.exports = __webpack_public_path__ + "img/cooperative0_logo29.d3df09e4.jpg";